import { Box } from "@mui/material"
import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router"
import { useCallback, useEffect, useState } from "react"
import { z } from "zod"

import { CompanySortField, CompanyStatus, SortingOrder } from "@/graphql/codegen/graphql"
import { SupplierReportFilterDrawer } from "@/screens/Procurement/Supplier/components/Filters/SupplierReportFilterDrawer"
import { SupplierReportSearch } from "@/screens/Procurement/Supplier/components/SupplierReportSearch"
import { SupplierReportTable } from "@/screens/Procurement/Supplier/components/Table/SupplierReportTable"
import { SUPPLIER_QUERY_TYPES } from "@/screens/Procurement/Supplier/utils/supplierReportConstants"
import { getRefinedSearchParams } from "@/utils/getRefinedSearchParams"

const supplierReportSearchSchema = z.object({
  category: z.string().optional(),
  query: z.string().optional(),
  field: z.nativeEnum(CompanySortField).optional(),
  order: z.nativeEnum(SortingOrder).optional(),
  types: z.array(z.string()).optional(),
  statuses: z.array(z.nativeEnum(CompanyStatus)).optional(),
  managers: z.array(z.string()).optional(),
})

const SupplierReport = () => {
  const [isFilterDrawerOpen, setFilterDrawerOpen] = useState(false)

  const toggleFilterDrawer = useCallback(() => setFilterDrawerOpen((prev) => !prev), [])
  const navigate = useNavigate({ from: "/app/procurement/_layout/supplier-report" })
  const currentSearch = useSearch({
    from: "/app/procurement/_layout/supplier-report",
  })

  useEffect(() => {
    const params = getRefinedSearchParams(currentSearch, {
      ...currentSearch,
      types: SUPPLIER_QUERY_TYPES,
      statuses: [CompanyStatus.Active],
    })
    void navigate(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <SupplierReportFilterDrawer showFilterDrawer={isFilterDrawerOpen} toggleDrawer={toggleFilterDrawer} />

      <SupplierReportSearch onShowFilter={toggleFilterDrawer} />

      <Box className='flex flex-1 flex-col overflow-y-auto'>
        <SupplierReportTable />
      </Box>
    </>
  )
}

export const Route = createFileRoute("/app/procurement/_layout/supplier-report")({
  component: SupplierReport,
  validateSearch: supplierReportSearchSchema,
})
